import React from 'react';
import { connect } from 'react-redux';
import loginService from '@core/services/login';
import platforms from '@core/constants/users/platforms';
import { Alert, AlertTitle, Avatar, Box, Button, CircularProgress, Dialog, Snackbar, Stack, TextField, Typography } from '@mui/material';
import { colorStatus } from '@ui/styles/colors/userStatusColors';
import { t } from 'i18next';
import { palette } from '@ui/styles/theme';
import '@ui/styles/sass/clients/clientTabs.scss';
import '@ui/styles/sass/clients/clientDialogs.scss';
class UserProfile extends React.Component {
    constructor (props) {
        super(props);
        this.state = {
            usuario: this.props.user,
            showPerfil: false,
            showNewPassword: false,
            alert: {
                severity: '',
                title: '',
                description: '',
                className: ''
            },
            openAlert: false,
            isLoading: false
        };
        this.close = this.close.bind(this);
    }

    changePassword = () => {
        this.setState({ ...this.state, isLoading: true });

        const body = {
            idPlatform: platforms.backoffice,
            email: this.state.usuario.person.email.description
        };

        loginService
            .forgot(body)
            .then(() => {
                this.setState({
                    ...this.state,
                    openAlert: true,
                    showPerfil: true,
                    showNewPassword: false,
                    isLoading: false,
                    alert: {
                        severity: 'success',
                        title: t('changePassword.title'),
                        description: t('changePassword.success'),
                        className: 'clientsMC_Alert--success'
                    }
                });
            })
            .catch(error => {
                this.setState({
                    ...this.state,
                    openAlert: true,
                    showPerfil: true,
                    showNewPassword: false,
                    isLoading: false,
                    alert: {
                        severity: 'success',
                        title: t('errors.generalTitle'),
                        description: t('errors.generalDescription'),
                        className: 'clientsMC_Alert--error'
                    }
                });
                console.error(error);
            });
    };

    openModalPerfil = () => {
        this.setState(() => ({ ...this.state, showPerfil: true, showNewPassword: false }));
    }

    openModalChangePassword = () => {
        this.setState(() => ({
            ...this.state, showPerfil: false, showNewPassword: true
        }));
    }

    close () {
        this.setState({ ...this.state, showPerfil: false, showNewPassword: false });
    }

    logout = () => {
        localStorage.removeItem('sessionUser');
        localStorage.removeItem('newEmail');
        this.props.history.push('/logout');
    }

    handleCloseSnack = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        this.setState({ ...this.state, openAlert: false });
        this.setState({
            ...this.state,
            alert: {
                severity: '',
                title: '',
                description: '',
                className: ''
            }
        });
    };

    render () {
        const { user } = this.props;
        const userNameSplit = this.state.usuario.formattedName.split(' ');
        const userInitials = userNameSplit[0].charAt(0) + userNameSplit[userNameSplit.length - 1].charAt(0);

        return (
            <>
                <Button appearance='subtle' onClick={this.openModalPerfil} style={{ marginTop: '20px' }}>
                    <Avatar style={{ color: 'white', backgroundColor: palette.primary[600] }}>{userInitials}</Avatar>
                </Button>
                <Dialog open={this.state.showPerfil} onClose={this.close} PaperProps={{ style: { padding: '32px', borderRadius: '16px', backgroundColor: palette.background.default } }}
                    show={this.state.showPerfil} onHide={this.close}>
                    <Stack width={'100%'} alignItems={'center'} gap={'1rem'} sx={{ paddingBottom: '4rem' }}>
                        <Stack gap={'1rem'} alignItems={'center'} justifyContent={'center'}>
                            <Box className='clientData--avatar' sx={{ marginRight: '0px !important' }}>
                                <span>{userInitials}</span>
                            </Box>
                            <Typography className="userName" variant='h4'>{this.state.usuario.formattedName}</Typography>
                            <Typography sx={{ width: '4.615rem' }} className='clientStatus' style={colorStatus[this.state?.usuario?.status?.description]}>{t(`profile.status.${[this.state?.usuario?.status?.id]}`) || ''} </Typography>
                        </Stack>
                        <Stack width={'100%'} gap={'1rem'}>
                            <TextField className="userModal" focused variant="standard" label={this.props.t('profile.document')} defaultValue={user.person.document?.description || ''} InputProps={{ readOnly: true }} />
                            <TextField className="userModal" focused variant="standard" label={this.props.t('profile.role')} defaultValue={t(`profile.status.${user?.roles[0].role?.description}`) || ''} InputProps={{ readOnly: true }} />
                            <TextField className="userModal" focused variant="standard" label={this.props.t('profile.email')} defaultValue={user.person.email?.description || ''} InputProps={{ readOnly: true }} />

                        </Stack>

                    </Stack>
                    <Stack direction={'row'} alignItems={'center'} gap={'1rem'} justifyContent={'center'}>
                        <Button
                            className='passwordButton'
                            onClick={this.openModalChangePassword}
                            sx={{ minWidth: '200px' }}
                        >{this.props.t('changePassword.title')}
                        </Button>
                        <Button
                            className='buttonAction'
                            onClick={this.logout}
                            sx={{ minWidth: '200px' }}
                        >{this.props.t('logout')}
                        </Button>
                    </Stack>
                    {this.state.openAlert && (
                        <Snackbar
                            open={this.state.openAlert}
                            autoHideDuration={6000}
                            onClose={this.handleCloseSnack}
                            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                            sx={{ zIndex: 10 }}
                        >
                            <Alert
                                className={alert.className}
                                onClose={this.handleCloseSnack}
                                severity={this.state.alert.severity}
                                variant='filled'
                            >
                                <AlertTitle color='white'>{this.state.alert.title}</AlertTitle>
                                {this.state.alert.description}
                            </Alert>
                        </Snackbar>
                    )}
                </Dialog>
                {/* Change password */}
                <Dialog PaperProps={{ style: { padding: '32px', borderRadius: '16px' } }} open={this.state.showNewPassword} onClose={this.close}>
                    <Box
                        display='flex'
                        justifyContent='center'
                        flexDirection='column'
                        gap={'40px'}
                        width={'396px'} >
                        <Box
                            display='flex'
                            flexDirection='column'
                            textAlign='center'
                            justifyContent='center'>
                            <span className='delete_text-title'>{t('changePassword.warning')}</span>
                        </Box>
                        <Box
                            display='flex'
                            justifyContent='right'
                            gap='32px'>
                            <Button className='delete_button--cancel' onClick={this.openModalPerfil}>
                                {t('buttons.back')}
                            </Button>
                            <Button className="delete_button--submit" appearance="primary" onClick={this.changePassword} disabled={this.state.isLoading}>
                                {(this.state.isLoading ? <CircularProgress size={24} style={{ color: 'white' }} />
                                    : t('buttons.accept'))}
                            </Button>
                        </Box>
                    </Box>
                </Dialog>
            </>
        );
    }
}

const mapStateToProps = ({ auth: { user } }) => ({
    user
});

export default connect(mapStateToProps)(UserProfile);
